import { GET_HANDYMAN_LIST } from './actions';
import { HandymanViewModel } from '../../configuration/api/apiSchema';

export interface HandymanState {
    isLoading: boolean;
    handymanList?: HandymanViewModel[];
    error?: string;
}

const initialState: HandymanState = {
    isLoading: false,
    handymanList: undefined,
    error: undefined
};

export const reducer = (state = initialState, action: any): HandymanState => {
    switch (action.type) {
        case GET_HANDYMAN_LIST.REQUEST:
            return {
                ...state,
                isLoading: true,
                error: undefined
            };
        case GET_HANDYMAN_LIST.SUCCESS:
            return {
                ...state,
                isLoading: false,
                handymanList: action.handymanList,
                error: undefined
            };
        case GET_HANDYMAN_LIST.FAILURE:
            return {
                ...state,
                isLoading: false,
                error: action.error
            };
        default:
            return state;
    }
};